import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Användare", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsersFormModal = _resolveComponent("UsersFormModal")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_UsersRemoveModal = _resolveComponent("UsersRemoveModal")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showUsersFormModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showUsersFormModal) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        (_ctx.showUsersFormModal)
          ? (_openBlock(), _createBlock(_component_UsersFormModal, {
              key: 0,
              user: _ctx.selectedUser,
              mode: _ctx.mode,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showUsersFormModal = false)),
              roles: _ctx.roles
            }, null, 8, ["user", "mode", "roles"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showUserRemoveModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showUserRemoveModal) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        (_ctx.showUserRemoveModal)
          ? (_openBlock(), _createBlock(_component_UsersRemoveModal, {
              key: 0,
              user: _ctx.selectedUser,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUserRemoveModal = false))
            }, null, 8, ["user"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_table, {
      class: _normalizeClass([_ctx.$style.stickyHeader, "shadow-0"]),
      columns: _ctx.columns,
      title: "Avvikelser",
      rows: _ctx.rows,
      loading: _ctx.loading,
      "rows-per-page-options": [0],
      style: _normalizeStyle(_ctx.tableStyle),
      filter: _ctx.filter,
      "hide-bottom": "",
      "row-key": "uuid"
    }, {
      "top-left": _withCtx(() => [
        _hoisted_1
      ]),
      "top-right": _withCtx(() => [
        _createVNode(_component_q_input, {
          dense: "",
          debounce: "300",
          modelValue: _ctx.filter,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter) = $event)),
          placeholder: "Sök..."
        }, {
          append: _withCtx(() => [
            _createVNode(_component_q_icon, { name: "mdi-magnify" })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_btn, {
          label: "Lägg till",
          class: "q-ml-md",
          onClick: _ctx.onShowAddUserModal
        }, null, 8, ["onClick"])
      ]),
      "body-cell-_actions": _withCtx((props) => [
        _createVNode(_component_q_td, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_btn_dropdown, {
              size: "sm",
              flat: "",
              round: "",
              color: "grey-7",
              "dropdown-icon": "mdi-dots-vertical",
              "content-class": "no-border-radius"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionItems, (actionItem) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        clickable: "",
                        onClick: ($event: any) => (actionItem.action(props.row)),
                        key: actionItem.label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(actionItem.label), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_close_popup]
                      ])
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["class", "columns", "rows", "loading", "style", "filter"])
  ], 64))
}